function videoLoad() {
    const videoLoadItems = document.querySelectorAll('.js-video-load__wrapper');
    // const videoLoadItem = [...videoLoadItems];
//const buttons = document.querySelectorAll(".video-group-embed__wrapper .js__embed__button");
    console.log(videoLoadItems);
    console.log(videoLoadItems.length > 0);
    if (videoLoadItems.length > 0) {

        videoLoadItems.forEach((element, i) => {
            // $.each(livestream, function(i) {
            const button = element.getElementsByClassName('js__embed__button')[0];
            const lsPH = element.getElementsByClassName('livestream__placeholder')[0];
            const iframeWrap = element.getElementsByClassName('js-video-container')[0];
            const loader = element.getElementsByClassName('js-load-wrapper')[0];
            const iframe = element.getElementsByClassName('video__iframe')[0];

            if (lsPH && lsPH.dataset.maxresSrc) {
                const maxresImage = new Image();
                maxresImage.onload = () => {
                    // Reject YouTube's small unavailable-image placeholder, too.
                    if (maxresImage.naturalWidth >= 1280) {
                        lsPH.src = maxresImage.src;
                    }
                };
                // Probe separately so a failed request leaves the HQ image visible.
                maxresImage.src = lsPH.dataset.maxresSrc;
            }
            console.log(button);
            console.log(iframe);

            const toggleLivBtn = (function () {
                if (button.classList.contains('clicked')) {
                    //button.classList.remove('visually-hidden');
                    button.innerHTML = "Watch Now";
                    lsPH.classList.remove('visually-hidden');
                    iframeWrap.classList.add('visually-hidden');
                    iframe.removeAttribute('src', 'about:blank');
                    loader.classList.remove('visually-hidden');
                } else {
                    button.classList.add('visually-hidden');
                    //button.innerHTML = "Close Stream";
                    lsPH.classList.add('visually-hidden');
                    iframeWrap.classList.remove('visually-hidden');
                    iframe.setAttribute('src', iframe.getAttribute('data-src'));
                    loader.classList.add('visually-hidden');
                }

            });

            if (button) {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    toggleLivBtn();
                    console.log('click');
                });

                button.addEventListener('keypress', (e) => {
                    if (e.charCode === 13) {
                        e.preventDefault();
                        toggleLivBtn();
                    }
                });
            }

        });
    }
}

videoLoad();